import { Moon, Sun } from '@nrx/ui/icons';
import type { JSX } from 'react';

import { useDocsTheme } from '../../theme/docs-theme-provider.js';

/** Toggle between light and dark documentation themes. */
export function ThemeToggle(): JSX.Element {
  const { theme, toggleTheme } = useDocsTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
      className="inline-flex shrink-0 items-center justify-center rounded-lg border border-[var(--color-docs-border)] bg-[var(--color-docs-surface)] p-2 text-[var(--color-docs-ink)] hover:bg-[var(--color-docs-code-bg)]"
    >
      {theme === 'light' ? (
        <Moon aria-hidden className="size-4" strokeWidth={2} />
      ) : (
        <Sun aria-hidden className="size-4" strokeWidth={2} />
      )}
    </button>
  );
}
